import DaumPostcode, { Address } from 'react-daum-postcode';

import ModalBox from '../../Modal/ModalBox/ModalBox';
import ModalPortal from '../../Modal/ModalPortal/ModalPortal';

interface InputAddressProps {
	setIsOpen: (isOpen: boolean) => void;
	setAddress: (address: Address) => void;
}
const InputAddress = ({ setIsOpen, setAddress }: InputAddressProps) => {
	const themeObj = {
		postcodeTextColor: '#FA7142',
		emphTextColor: '#333333',
	};
	const completeHandler = (data: Address) => {
		setAddress(data);
	};
	const closeHandler = (state: string) => {
		if (state === 'FORCE_CLOSE') {
			setIsOpen(false);
			console.log('FORCE_CLOSE');
		} else if (state === 'COMPLETE_CLOSE') {
			setIsOpen(false);
			console.log('COMPLETE_CLOSE');
		}
	};
	const style = {
		width: '400px',
		height: '600px',
		border: '1.4px solid #333333',
	};

	return (
		<ModalPortal>
			<ModalBox title="주소찾기" onClick={setIsOpen}>
				<DaumPostcode theme={themeObj} style={style} onComplete={completeHandler} onClose={closeHandler} />
			</ModalBox>
		</ModalPortal>
	);
};

export default InputAddress;
